var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberShipp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H2.5C1.12125 0 0 1.12125 0 2.5V17.5C0 18.8787 1.12125 20 2.5 20H22.5C23.8787 20 25 18.8787 25 17.5V2.5C25 1.12125 23.8787 0 22.5 0ZM14.8088 8.55875L11.9275 10.8913L12.8888 14.4362C13.01 14.8787 12.5262 15.2437 12.125 15.015L8.765 13.0912L5.4625 15.03C5.07125 15.26 4.59 14.9175 4.68875 14.4775L5.485 10.8888L2.68625 8.555C2.33375 8.26 2.515 7.69125 2.97375 7.65L6.7725 7.30125L8.2875 3.95125C8.47125 3.545 9.0525 3.545 9.2375 3.95125L10.7525 7.30125L14.525 7.6475C14.99 7.69125 15.1687 8.26625 14.8088 8.55875ZM16.25 15C15.56 15 15 14.44 15 13.75C15 13.06 15.56 12.5 16.25 12.5C16.94 12.5 17.5 13.06 17.5 13.75C17.5 14.44 16.94 15 16.25 15ZM21.25 15C20.56 15 20 14.44 20 13.75C20 13.06 20.56 12.5 21.25 12.5C21.94 12.5 22.5 13.06 22.5 13.75C22.5 14.44 21.94 15 21.25 15Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberShipp);
export default __webpack_public_path__ + "static/media/MemberShipp.9f07fdb0124c5e1d6f40b711bea5c45b.svg";
export { ForwardRef as ReactComponent };